export enum AppDocumentType {
  GuaranteeTermsAndConditions = 'guarantee-terms-and-conditions',
  Ipid = 'ipid',
  TermsAndConditions = 'terms-and-conditions',
}
